import React from "react";
import styled from "styled-components";
import { displayPhone, normalizePhone } from "sweet-global";
import PhoneIcon from "sweet-web/components/icons/PhoneIcon";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { globalInputStyles, IconWrapper } from "./index";

const Wrapper = styled.div`
  padding: 10px 0 10px 0;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  ${globalInputStyles}
  width: 100%;
  padding-left: 35px;
`;

type Props = {
  title?: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
};
const PhoneNumberInput: React.FC<Props> = props => {
  return (
    <Wrapper>
      {props.title && <ItemTitle>{props.title}</ItemTitle>}
      {props.description && <ItemLabel>{props.description}</ItemLabel>}
      <Input
        type="tel"
        inputMode="numeric"
        key={"number-input"}
        id={"number-input"}
        value={props.value ? displayPhone(props.value) : ""}
        onChange={e => {
          const text = e.target.value;
          let trueText = text;
          if (props.value) {
            const lastChar = displayPhone(props.value)[
              displayPhone(props.value).length - 1
            ];
            if (
              text.length < displayPhone(props.value).length &&
              [" ", "-", "(", ")"].includes(lastChar)
            ) {
              // user trying to remove number but hitting other character
              if (lastChar == "-")
                trueText = trueText.slice(0, trueText.length - 1);
              else trueText = trueText.slice(0, trueText.length - 2);
            }
          }

          props.onChange(normalizePhone(trueText));
        }}
        onBlur={props.onBlur}
      />
      <IconWrapper>
        <PhoneIcon size={14} />
      </IconWrapper>
    </Wrapper>
  );
};
PhoneNumberInput.defaultProps = {
  title: "Phone Number",
  onBlur: () => {}
};

export default PhoneNumberInput;
